<template>
  <vue-final-modal v-model="state" classes="modal-container" content-class="modal-content" :click-to-close="true" teleport-to="body">
    <div class="modal-header justify-content-between">
      <span class="modal__title text-white">Attestation of Policy</span>
      <div>
        <button type="button" class="btn-close" aria-label="Close" @click="closeDialog()"></button>
      </div>
    </div>

    <div class="modal__body">
      <div class="modal__content mt-3 mb-4">
        <div v-if="isAttested">
          <template v-if="Array.isArray(filteredData)">
            <div>
              Attestation was completed on <small><strong>{{ formatDate(filteredData[0].attested.date_attested) }}</strong></small>.
              <br>
              <span v-for="(item, index) in filteredData" :key="index">
                <a href="#" @click="handleLinkClick(item)">{{ truncatedLink(item.name) }}</a>
                <br v-if="index < filteredData.length - 1">
              </span>
            </div>
          </template>
          <template v-else>
            <div class="col-12">
              Attestation was completed on <small><strong>{{ formatDate(filteredData.attested.date_attested) }}</strong></small>.
            </div>
            <a href="#" @click="handleLinkClick(filteredData)">{{ truncatedLink(filteredData.name) }}</a>
          </template>
        </div>

        <div v-else>
          <div v-if="Array.isArray(filteredData)">
            <div>
              <span v-if="filteredData.length > 1">
                I confirm I have read and agree to adhere to the Policy and Procedure available at these links:
              </span>
              <span v-else>I confirm I have read and agree to adhere to the Policy and Procedure:</span>
              <br>
              <span v-for="(item, index) in filteredData" :key="index">
                <a href="#" @click="handleLinkClick(item)">{{ truncatedLink(item.name) }}</a>
                <br v-if="index < filteredData.length - 1">
              </span>
            </div>
          </div>
          <div v-else>
            I confirm I have read and agree to adhere to the Policy and Procedure:
            <br>
            <a href="#" @click="handleLinkClick(filteredData)">{{ truncatedLink(filteredData.name) }}</a>.
          </div>
        </div>
      </div>
      <div class="modal__action">
        <button class="btn btn-primary ms-3" style="text-transform: capitalize;" :disabled="!linkClicked" type="button" @click="confirmAttest" v-show="!isAttested">
          Attest to Policy
        </button>
      </div>
    </div>

  </vue-final-modal>
</template>

<script>
import moment from "moment";

export default{
  name: "DeleteForm",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    isAttested: {
      type: Boolean,
      required: true,
    },
    data: {
      required: true,
    },
  },

  data() {
    return {
      state: this.dialog,
      linkClicked: false,
      linkClickedCount: 0,
      totalLinks: 0,
      linkClickeds: [],
      localData: Array.isArray(this.data) ? [...this.data] : this.data
    };
  },

  mounted() {
    // Calculate totalLinks based on filteredData
    if (Array.isArray(this.filteredData)) {
      this.totalLinks = this.filteredData.length;
    } else {
      this.totalLinks = 1; // Handle case where filteredData is not an array
    }
  },

  methods: {
    handleLinkClick(item) {
      if (!item.link.includes("http")) {
        this.openLinkInNewTab("https://" + item.link);
      } else {
        this.openLinkInNewTab(item.link);
      }

      // Check if the current link has not been clicked before
      if (!this.linkClickeds.includes(item.ID)) {
        // Increment the clicked link count
        this.linkClickedCount++;
        // Mark the current link as clicked
        this.linkClickeds.push(item.ID);
      }

      // Check if all links have been clicked
      if (this.linkClickedCount === this.totalLinks) {
        this.linkClicked = true;
      }
    },

    openLinkInNewTab(link) {
      window.open(link, '_blank');
    },

    truncatedLink(link) {
      const maxLength = 50;


      let truncated = link.substring(0, maxLength);
      if (link.length > maxLength) {
        truncated += '...';
      }

      return truncated;
    },

    async confirmAttest() {

      let strippedData = this.filteredData

      //clean link and get filename if policy is uploaded from gcs
      strippedData.forEach(data => {
        data.link = this.extractFilenameFromGCSUrl(data.link);
      });

      this.$emit("onChange", { data: strippedData });
      this.state = false;
    },

    extractFilenameFromGCSUrl(url) {
      // Define the base URL for GCS
      const gcsBaseUrl = 'https://storage.googleapis.com/';

      // Check if the URL starts with the GCS base URL
      if (url.startsWith(gcsBaseUrl)) {
        // Remove the base URL to get the path
        const path = url.slice(gcsBaseUrl.length);

        // Split the path by '/' to separate the bucket name and file path
        const pathParts = path.split('/');

        // The filename is the last part of the path
        const filename = pathParts.pop().split('?')[0]; // Remove query parameters if present

        return filename || url; // Return filename if present, else return original URL
      } else {
        // If the URL is not from GCS, return the original URL
        return url;
      }
  },

    formatDate(date){
      if (!date) return ""
      return moment(date).local().format("DD MMMM YYYY / hh:mm:ss A");

    },

    closeDialog() {
      this.$emit("close");
      this.state = false;
    },
  },

  computed: {
    filteredData() {
      let data = this.data;

      // Ensure data is an array
      if (!Array.isArray(data)) {
        return data = [data];
      }

      // Filter data based on your condition
      const filtered = data.filter(item => {
        if (this.isAttested) {
          // If viewing an already attested policy, show it regardless of current requirement status
          return item.attested && item.attested.ID !== 0;
        } else {
          // If prompting for a new attestation, only show required policies that haven't been attested
          return item.required && (!item.attested || item.attested.ID === 0);
        }
      });

      filtered.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      });

      return filtered;
    }
  },

  watch: {
    dialog(newVal) {
      this.state = newVal;
    },
  },

};
</script>

<style scoped>
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  border-radius: 10px;
  background: #fff !important;
  width: 30% !important;
}

.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.2rem;
  font-weight: 700;
}

.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 1rem 0 0;
}

.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

@media screen and (max-width: 900px) {
:deep(.modal-content) {
  width: 95%;
}
}

.btn.disabled, .btn:disabled, fieldset:disabled .btn {
	color: white;
	pointer-events: none;
	background-color: #435666;
	border-color: #435666;
	opacity: .5;
}
</style>
